import moment from "moment";
import React, { useEffect } from "react";
import hallImg from "../../assets/images/resume.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    deleteBookMarkRequest,
    fetchBookMarkRequest,
} from "../../store/social/social.actions";
import { getBookMarks } from "../../store/social/social.selector";
import { getImage } from "../../store/user/user.selector";
import LiveStreamCard from "../Profile/liveStreamCard";
import { useState } from "react";
import Swal from "sweetalert2";

const Starred = () => {
    const dispatch = useDispatch();
    const [edit, setEdit] = useState(false);

    const { bookmarks } = useSelector((state) => {
        return {
            bookmarks: getBookMarks(state),
        };
    });

    useEffect(() => {
        dispatch(fetchBookMarkRequest());
    }, []);

    useEffect(() => {
        if (bookmarks.length === 0) {
            setEdit(false);
        }
    }, [bookmarks]);

    let bookmark = bookmarks
        .filter((x) => x.livestream.status === "Active")
        .map((z) => {
            let item = z.livestream;
            let duration = "00 : 00 : 00";
            if (
                item.durationTime &&
                item.streamingStatus.toLowerCase() !== "waiting"
            ) {
                let ms = item.durationTime * 1000;
                var d = moment.duration(ms);
                duration = `${d._data.hours
                    .toString()
                    .padStart(2, "0")} : ${d._data.minutes
                    .toString()
                    .padStart(2, "0")} : ${d._data.seconds
                    .toString()
                    .padStart(2, "0")}`;
            }
            return {
                id: item._id,
                img: hallImg,
                title: item.title,
                watch: item.totalWatch,
                comment: item.comments,
                date: moment(item.dateCreated).fromNow(),
                duration: duration,
                users: {
                    owner: {
                        name: item.owner.fullName,
                        userName: item.owner.userName,
                        image: getImage(item.owner.attachments),
                    },
                    guests: item.guestStats.map((x) => {
                        return {
                            name: x.fullName,
                            image: getImage(x.attachments),
                        };
                    }),
                },
                streamUrl: item.streamUrl,
                attachments: item.attachments,
                streamingStatus: item.streamingStatus,
                bookMarkId: z._id,
                s3Url: item.s3Url,
            };
        });

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="mb-[18px]">
                <div className="flex flex-col xs:flex-row gap-y-3 items-center justify-between mb-4">
                    <div>
                        <h2 className="text-xl font-bold text-ebony-color capitalize">
                            Starred
                        </h2>
                        <p className="text-sm font-medium text-black-50">
                            Discover a list of videos that you have saved
                        </p>
                    </div>
                    {bookmarks.length > 0 && (
                        <div className="space-x-3 flex items-center">
                            {edit ? (
                                <>
                                    <button
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Confirm delete?",
                                                text: "All deleted starred livestream cannot be restored later.",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "red",
                                                cancelButtonText: "Cancel",
                                                confirmButtonText: "Delete",
                                                customClass: {
                                                    cancelButton:
                                                        "order-1 right-gap",
                                                    confirmButton: "order-2",
                                                    denyButton: "order-3",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    dispatch(
                                                        deleteBookMarkRequest({
                                                            listBookmarkId:
                                                                bookmarks.map(
                                                                    (x) => x._id
                                                                ),
                                                        })
                                                    );
                                                }
                                            });
                                        }}
                                        className="py-2.5 px-5 rounded-lg capitalize text-sm bg-white text-black-50 border border-black-10 font-medium"
                                    >
                                        Remove all
                                    </button>
                                    <button
                                        onClick={() => setEdit(false)}
                                        className="py-2.5 px-5 rounded-lg capitalize text-sm bg-orange-color text-white border border-transparent font-bold"
                                    >
                                        Done
                                    </button>
                                </>
                            ) : (
                                <button
                                    onClick={() => setEdit(true)}
                                    className="py-2.5 px-5 rounded-lg capitalize text-sm bg-orange-color text-white border border-transparent font-bold"
                                >
                                    Edit
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="p-4 bg-white rounded-lg border border-black-10 flex-grow overflow-y-auto">
                <h3 className="text-sm font-bold text-ebony-color mb-3.5">
                    Starred videos by me
                </h3>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {bookmark.map((stream) => {
                        return (
                            <LiveStreamCard
                                stream={stream}
                                isBookmarking={edit}
                            />
                        );
                    })}
                </div>
                {bookmarks.length === 0 && (
                    <div className="flex flex-col items-center justify-start pt-9 w-full">
                        <p className="text-sm text-black-50 mb-5">
                            You do not have any starred videos yet
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Starred;
